import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ValidationService {

    isValidationScreen: boolean;
    isFormValidated: boolean;
    isResponseOk: boolean;


    setValidationState(state: boolean) {
        this.isValidationScreen = state;
    }

    setFormState(state: boolean) {
        this.isFormValidated = state;
    }

    setResponseState(state: boolean) {
        this.isResponseOk = state;
    }

    isValidAccess() {
        return (this.isValidationScreen && this.isFormValidated && this.isResponseOk);
    }
}
